<template>
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 p-5"
    @click.self="$emit('close')"
  >
    <div
      class="relative flex max-h-[80vh] max-w-[90vw] touch-none items-center justify-center"
      :class="backgroundClasses"
      :style="{ backgroundColor: computedImageBackground }"
    >
      <div class="absolute right-3 top-3 z-[10000]">
        <button
          class="pointer-events-auto relative z-[10001] flex h-9 w-9 items-center justify-center rounded-full border-none bg-gray-800/40 text-white transition-all hover:bg-gray-800/60"
          type="button"
          @click="$emit('close')"
        >
          <svg class="h-4 w-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div
        :class="[
          'flex h-full w-full items-center justify-center overflow-hidden rounded-lg',
          wrapperClass,
          backgroundClasses
        ]"
        :style="{ backgroundColor: computedImageBackground }"
      >
        <ZoomImage data-testid="mobile-image-modal-zoom-image" :src="src" alt="Preview Image" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";

import { BACKGROUND_TYPE, COLORS } from "components/jiffy/design-lab/shared/constants";

import { useDtfStore } from "../store";
import ZoomImage from "./ZoomImage.vue";

export default {
  name: "MobileImageModal",
  components: { ZoomImage },
  props: {
    src: { type: String, required: true },
    wrapperClass: { type: String, required: true },

    imageBackground: {
      type: String,
      default: "transparent"
    }
  },
  computed: {
    ...mapState(useDtfStore, ["backgroundType"]),
    computedImageBackground() {
      if (this.backgroundType === BACKGROUND_TYPE.GREEN) {
        return COLORS.GREEN_BACKGROUND;
      }
      return this.imageBackground;
    },
    backgroundClasses() {
      return {
        "transparent-bg":
          this.imageBackground === "transparent" &&
          this.backgroundType === BACKGROUND_TYPE.CHECKERED,
        "green-bg": this.backgroundType === BACKGROUND_TYPE.GREEN
      };
    }
  },
  emits: ["close"]
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";

.transparent-bg {
  background: $transparent-bg;
}

.green-bg {
  background-color: v-bind(computedImageBackground);
}
</style>
